import React, { useState, useEffect } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import { smartChat } from 'api'
import { updateActionsErrors } from 'redux/smartchat/details/actions'
import { setAlternativesActionsErrors } from 'redux/smartchat/alternatives/actions'
import RandomResponsesViewUI from './RandomResponsesViewUI'
import { getDataOptions } from 'components/SmartChatView/utils'

const RandomResponsesView = ({ renderType, label, placeholder, dataWay, currentValue, onChange, link, error }) => {
  const { modalActionRef } = useSelector(store => ({
    modalActionRef: dataWay?.type === 'alternatives'
      ? store.smartchatAlternatives.alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === dataWay.alternativesId) || {}
      : store.smartchatDetails.modalActionRef
  }), shallowEqual)
  const dispatch = useDispatch()
  const [randomResponsesOptions, setRandomResponsesOptions] = useState(null)
  const [value, setValue] = useState({})
  const [dataToExport, setDataToExport] = useState(currentValue || {})
  const [loadingRandomResponsesOptions, setLoadingRandomResponsesOptions] = useState(false)
  const [previewIntegrity, setPreviewIntegrity] = useState(null)

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed && !randomResponsesOptions) getRandomResponsesOptions()

    return () => isSubscribed = false
  }, [])

  // Current data
  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (!currentValue || !Object.keys(currentValue).length) return

      if (renderType === 'action') {
        if (modalActionRef.mode !== 'update') return
        onChange(currentValue)
      }

      let updatedValue = { ...value }
      let updatedPreviewIntegrity = previewIntegrity

      // Random responses
      if (randomResponsesOptions?.length) {
        const option = randomResponsesOptions.find(option => option.value === currentValue.messageId)
        if (option) {
          if (updatedPreviewIntegrity) updatedPreviewIntegrity = null
          updatedValue.randomResponses = option
          if (renderType === 'preview') getRandomResponsesCount(option.value)
        } else {
          // Error report
          if (renderType === 'action') {
            dataWay?.type === 'alternatives'
              ? dispatch(setAlternativesActionsErrors({ alternativesId: dataWay.alternativesId, actionsErrors: { emitAutoBotMessage: I18n.t('smartchat_tooltip_warning_notFound') } }))
              : dispatch(updateActionsErrors({ emitAutoBotMessage: I18n.t('smartchat_tooltip_warning_notFound') }))
          } else {
            updatedPreviewIntegrity = I18n.t('smartchat_tooltip_warning_notFound')
          }
        }
      }

      // Update local data
      setValue(updatedValue)

      // Error report
      if (renderType === 'preview' && updatedPreviewIntegrity) setPreviewIntegrity(updatedPreviewIntegrity)
    }

    return () => isSubscribed = false
  }, [currentValue, randomResponsesOptions])

  const getRandomResponsesOptions = async () => {
    setLoadingRandomResponsesOptions(true)
    try {
      const { randomResponsesOptions } = await getDataOptions({ requestedData:['randomResponsesOptions'] })
      setRandomResponsesOptions(randomResponsesOptions)
    } finally {
      setLoadingRandomResponsesOptions(false)
    }
  }

  const getRandomResponsesCount = async (messageId) => {
    const { data } = await smartChat.getMessageGroup()
    const messagesGroup = data.groupsInfo.groups.find(messagesGroup => messagesGroup._id === messageId)
    setValue(prevState => ({
      ...prevState,
      count: messagesGroup.messages.length
    }))
  }

  const onChangeInner = (randomResponsesData) => {
    const updatedValue = { ...value }
    const updatedDataToExport = { ...dataToExport }

    // Data to export
    if (randomResponsesData) {
      updatedValue.randomResponses = randomResponsesData
      updatedDataToExport.messageType = 'messageTable'
      updatedDataToExport.messageId = randomResponsesData.value
    }

    // Update local data
    setValue(updatedValue)
    setDataToExport(updatedDataToExport)

    // Export the data
    onChange(updatedDataToExport)
  }

  return (
    <RandomResponsesViewUI
      renderType={renderType}
      label={label}
      placeholder={placeholder}
      randomResponsesOptions={randomResponsesOptions}
      value={value}
      onChangeInner={onChangeInner}
      link={link}
      loadingRandomResponsesOptions={loadingRandomResponsesOptions}
      error={error}
      previewIntegrity={previewIntegrity}
    />
  )
}

export default RandomResponsesView
